module.exports = __webpack_public_path__ + "05f9bc6f964c54d41f8cc6aaac855aff.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_medium_x1/public/team/Leadership_AlexP_0.jpg
// module id = 389
// module chunks = 0